import { render, staticRenderFns } from "./AccountOpening.vue?vue&type=template&id=aeb2e158&"
import script from "./AccountOpening.vue?vue&type=script&lang=js&"
export * from "./AccountOpening.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports